import $ from 'jquery';
import 'arrive';

$(document).ready(function() {
    document.arrive('.block-ipo-financial-files-list', {existing: true}, function() {

    });
});